import React, { Component } from 'react';
import {Form, Control, Errors} from "react-redux-form";
import { isRequired } from "../field_validations";
//import Loading from './../../elements/loading';

class ContentFormPermissions extends Component {
	render(){
		return(
			<div className="columns is-centered">
				<div className="column is-10">
					<Form model="permissions.edit" onSubmit={(values) => this._handleSubmit(values)} onSubmitFailed={(error) => {this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger'); console.log('error', error)}}>
						<div className="columns is-multiline">
							<div className="column is-12">
								<p className="title is-5">Permisos del Sistema</p>
								<div className="field is-grouped">
									<div className="control is-expanded">
										<label htmlFor="display" className="label">Descripción <span className="small has-text-danger">*</span></label>
										<Control.text model=".display" id="display" className="input" errors={{isRequired}} validateOn="change"/>
										<Errors model=".display" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El campo es obligatorio'}} />
									</div>

									<div className="control is-expanded">
										<label htmlFor="name" className="label">Nombre</label>
										<Control.text model=".name" id="name" className="input"/>
									</div>
								</div>
							</div>
						</div>

						<div className="columns">
							<div className="column">
								<div className="field is-grouped is-grouped-right">
									<div className="control">
										<button type="button" className="button is-danger" onClick={() => this.props.history.push('/permisos')}>
											Regresar
										</button>
									</div>
									<div className="control">
										<Control.button model="permissions.edit" className="button is-success" type="submit" disabled={{pristine:true}}>
											Guardar
										</Control.button>
									</div>
								</div>
							</div>
						</div>

						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
					</Form>
				</div>
			</div>
		);
	}

	_handleSubmit(values) {
		this.props.permissionsSave(values);
	}
}

export default ContentFormPermissions;


// WEBPACK FOOTER //
// ./src/elements/permissions/form.jsx